import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";

const TRANSPARENCY_REPORTS_GENERATE_URL = `${QA_API_DOMAIN}/transparency-reports/generate`;

export interface GenerateTransparencyReportOptions {
  from: string;
  to: string;
  customer?: string;
}

export interface GenerateTransparencyReportResponse {
  bucket: string;
  key: string;
}

export async function generateTransparencyReport(
  options: GenerateTransparencyReportOptions,
): Promise<GenerateTransparencyReportResponse> {
  const body: { from: string; to: string; customer?: string } = {
    from: options.from,
    to: options.to,
  };
  if (options.customer !== undefined) {
    body.customer = options.customer;
  }

  const res = await fetchWithSupabaseAuth(TRANSPARENCY_REPORTS_GENERATE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const parsed = (await res.json().catch(() => ({}))) as {
      error?: string;
      message?: string;
      details?: unknown;
    };
    const message = parsed.message ?? parsed.error ?? res.statusText ?? "Failed to generate transparency report";
    throw new Error(message);
  }

  return res.json() as Promise<GenerateTransparencyReportResponse>;
}
